import { ISystemJob, TEAMS, TStoryContentElementType } from "@dl/declarations";
import * as yup from "yup";

export type JobFormData = Pick<
  ISystemJob,
  | "role"
  | "team"
  | "locations"
  | "categories"
  | "content_elements"
  | "is_active"
> & {
  _id?: string;
};

export const initialValues: JobFormData = {
  role: "",
  team: TEAMS.NEWSROOM.SLUG,
  locations: [],
  categories: [],
  content_elements: [],
  is_active: true,
};

export const schema = yup.object().shape({
  role: yup.string().required().label("Role"),
  team: yup.string().required().label("Team"),
  locations: yup.array().of(yup.string()).required().label("Locations"),
  categories: yup.array().of(yup.string()).required().label("Categories"),
  content_elements: yup
    .array()
    .of(yup.object<TStoryContentElementType>())
    .required()
    .label("Job content"),
  is_active: yup.boolean().required().label("Active status"),
});
